import { render, staticRenderFns } from "./purposHospitalization.vue?vue&type=template&id=36281d4e&"
import script from "./purposHospitalization.vue?vue&type=script&lang=js&"
export * from "./purposHospitalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports